export const POI_ANALYSIS_ACTIONS = [
  { type: 'drive-time', mode: 'time', label: 'Drive by Time', optionLabel: 'Time', valueLabel: 'Travel time', icon: 'bi-clock', placeholder: 'Enter time', unit: 'minutes' },
  { type: 'drive-distance', mode: 'distance', label: 'Drive by Distance', optionLabel: 'Distance', valueLabel: 'Travel distance', icon: 'bi-signpost-split', placeholder: 'Enter distance', unit: 'km' },
  { type: 'radius-distance', mode: 'radius', label: 'Distance by Radius', optionLabel: 'Radius', valueLabel: 'Radius', icon: 'bi-bullseye', placeholder: 'Enter radius in kilometers', unit: 'km' }
];

export const POI_ANALYSIS_MENU_ACTION = {
  label: 'Location based selection',
  icon: 'bi-bullseye'
};

export function getPoiAnalysisAction(mode) {
  return POI_ANALYSIS_ACTIONS.find(action => action.mode === mode);
}
